import { Tooltip as Base } from "@base-ui/react/tooltip";
import type { ReactElement, ReactNode } from "react";

import "./tooltip.css";

/** App-level provider (shares hover/focus timing across tooltips). Wrap the app once. */
export const TooltipProvider = Base.Provider;

export type TooltipSide = "top" | "bottom" | "left" | "right";

export interface TooltipProps {
  /** The trigger element (e.g. a Button/IconButton). */
  children: ReactElement;
  label: ReactNode;
  side?: TooltipSide;
  sideOffset?: number;
}

/**
 * Token-styled tooltip on Base UI's headless Tooltip. Shows on hover/focus, hides on
 * blur/Escape; `role="tooltip"` is wired automatically. Requires a `TooltipProvider` ancestor
 * (set the open/close `delay` there).
 */
export function Tooltip({ children, label, side = "top", sideOffset = 6 }: TooltipProps) {
  return (
    <Base.Root>
      <Base.Trigger render={children} />
      <Base.Portal>
        <Base.Positioner className="rc-tooltip-positioner" side={side} sideOffset={sideOffset}>
          <Base.Popup className="rc-tooltip">{label}</Base.Popup>
        </Base.Positioner>
      </Base.Portal>
    </Base.Root>
  );
}
